// 用户持券记录 Mock（对齐数据库权益券模块的用户券表）
// 界面不暴露表名/字段名
//
// 产品规则：
//  - 一券一固定核销码，发放时生成、终身不变；C 端展示数字串，二维码内容同此码。
//  - 券由后台发放产生：手动指定发放（所有券可用）/ 每月全员发放 / 里程碑发放（后两者为券种上的自动规则）。
//  - 券在自己手上使用才核销，后台只读流水，不做编辑。

import { BENEFIT_LIST } from './benefit'

export const USER_BENEFIT_STATUS = [
  { label: '未使用', value: 0 },
  { label: '已使用', value: 1 },
  { label: '已过期', value: 2 },
  { label: '已作废', value: 3 }
]

// 发放来源是固定枚举（0 后台指定 / 1 每月发放 / 2 里程碑发放），中文与配色走本地映射（见 mock/benefit.js）

export function userBenefitStatusText(status) {
  const hit = USER_BENEFIT_STATUS.find(s => s.value === status)
  return hit ? hit.label : '未知'
}

export function userBenefitStatusTagType(status) {
  if (status === 1) return 'success'
  if (status === 2) return 'info'
  if (status === 3) return 'danger'
  return 'warning'
}

// 核销码分组展示：6842 1937 5206
export function formatVerifyCode(code) {
  return String(code || '').replace(/(\d{4})(?=\d)/g, '$1 ')
}

// 列表脱敏由后端统一处理（持券记录列表返脱敏码），前端不再重复脱敏

// 完整核销码（含二维码）是否可见由后端按权限判定（无权限时详情接口不返 verify_code_full），
// 前端不再自行维护权限码判断

// 二维码示意图（按核销码确定性生成，仅用于后台直观呈现；线上由前端按核销码本地生成真码）
export function buildQrImage(code) {
  const N = 21
  const C = 8
  const S = N * C
  let seed = 0
  const s = String(code || '0')
  for (let i = 0; i < s.length; i++) seed = (seed * 31 + s.charCodeAt(i)) >>> 0
  if (!seed) seed = 1
  const next = () => {
    seed = (seed * 1103515245 + 12345) >>> 0
    return seed / 4294967296
  }
  const finderAt = (x, y) => {
    const zones = [[0, 0], [N - 7, 0], [0, N - 7]]
    for (let i = 0; i < zones.length; i++) {
      const zx = zones[i][0]
      const zy = zones[i][1]
      if (x >= zx && x < zx + 7 && y >= zy && y < zy + 7) {
        const lx = x - zx
        const ly = y - zy
        const border = lx === 0 || lx === 6 || ly === 0 || ly === 6
        const core = lx >= 2 && lx <= 4 && ly >= 2 && ly <= 4
        return border || core ? 1 : 0
      }
    }
    return -1
  }
  let cells = ''
  for (let y = 0; y < N; y++) {
    for (let x = 0; x < N; x++) {
      const fixed = finderAt(x, y)
      const on = fixed === -1 ? next() > 0.52 : fixed === 1
      if (on) cells += `<rect x="${x * C}" y="${y * C}" width="${C}" height="${C}"/>`
    }
  }
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${S}" height="${S}" viewBox="0 0 ${S} ${S}">
    <rect width="${S}" height="${S}" fill="#ffffff"/>
    <g fill="#241a14">${cells}</g>
  </svg>`
  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg)
}

const benefitOf = id => BENEFIT_LIST.find(b => b.id === id)

// 补齐券名、发放来源、二维码
// 来源 = 券种发放规则的快照（每月 > 里程碑 > 后台指定，固定枚举 0/1/2，与后端 source_type 同口径）
function finalize(item) {
  const b = benefitOf(item.benefit_id)
  const values = b ? (b.dispatch_ids || '').split(',').map(s => s.trim()) : []
  let sourceType = item.source_type
  if (sourceType === undefined || sourceType === null) {
    if (values.indexOf('monthly') > -1) sourceType = 1
    else if (values.indexOf('milestone') > -1) sourceType = 2
    else sourceType = 0
  }
  let desc = item.source_desc
  if (!desc) {
    if (sourceType === 1) desc = `每月 ${(b && b.dispatch_day) || 1} 日全员发放`
    else if (sourceType === 2) desc = `达成「${(b && b.milestone_label) || '指定条件'}」自动发放`
    else desc = '后台指定发放'
  }
  return Object.assign({}, item, {
    benefit_name: b ? b.name : (item.benefit_name || ''),
    source_type: sourceType,
    source_desc: desc,
    qrcode: buildQrImage(item.verify_code)
  })
}

// 用户券流水
export const USER_BENEFIT_LIST = [
  {
    id: 9001, user_id: 101, nickname: '塔塔得旅行日记', gender: 2, benefit_id: 1,
    verify_code: '684219375206', start_time: '2026-08-20 00:00:00', expire_time: '2026-12-31 23:59:59',
    status: 1, use_time: '2026-09-10 14:52:31', created_at: '2026-08-20 10:42:18',
    source_desc: '客服补偿：接驳车延误', operator_name: '张经理'
  },
  {
    id: 9002, user_id: 102, nickname: '桂林山水甲天下', gender: 1, benefit_id: 2,
    verify_code: '357194806312', start_time: '2026-09-01 00:00:00', expire_time: '2026-10-01 23:59:59',
    status: 1, use_time: '2026-09-06 09:24:37', created_at: '2026-09-01 08:15:02'
  },
  {
    id: 9003, user_id: 103, nickname: '清风入竹', gender: 1, benefit_id: 5,
    verify_code: '902384715620', start_time: '2026-07-12 00:00:00', expire_time: '2026-09-10 23:59:59',
    status: 2, use_time: null, created_at: '2026-07-12 19:03:44'
  },
  {
    id: 9004, user_id: 105, nickname: '梅子黄时雨', gender: 2, benefit_id: 3,
    verify_code: '516207394881', start_time: '2026-09-08 00:00:00', expire_time: '2026-09-23 23:59:59',
    status: 0, use_time: null, created_at: '2026-09-08 14:26:51'
  },
  {
    id: 9005, user_id: 106, nickname: '塔林常客·老周', gender: 1, benefit_id: 1,
    verify_code: '773920461558', start_time: '2026-06-05 00:00:00', expire_time: '2026-12-31 23:59:59',
    status: 1, use_time: '2026-06-18 15:40:09', created_at: '2026-06-05 09:12:30',
    source_desc: '老客户回访赠送', operator_name: '黄总'
  },
  {
    id: 9006, user_id: 108, nickname: '稻香人家', gender: 2, benefit_id: 2,
    verify_code: '240861597733', start_time: '2026-09-03 00:00:00', expire_time: '2026-10-03 23:59:59',
    status: 1, use_time: '2026-09-09 10:11:26', created_at: '2026-09-03 16:48:15'
  },
  {
    id: 9007, user_id: 109, nickname: '行走的老树', gender: 1, benefit_id: 5,
    verify_code: '468315702294', start_time: '2026-08-25 00:00:00', expire_time: '2026-10-24 23:59:59',
    status: 0, use_time: null, created_at: '2026-08-25 11:07:49'
  },
  {
    id: 9008, user_id: 110, nickname: '小满未满', gender: 2, benefit_id: 4,
    verify_code: '639058214477', start_time: '2026-03-15 00:00:00', expire_time: '2026-04-15 23:59:59',
    status: 2, use_time: null, created_at: '2026-03-16 20:31:05',
    source_desc: '春分祭典志愿者答谢', operator_name: '张经理'
  },
  {
    id: 9009, user_id: 111, nickname: '桂林·接引小站', gender: 0, benefit_id: 1,
    verify_code: '812476930165', start_time: '2026-07-20 00:00:00', expire_time: '2026-12-31 23:59:59',
    status: 0, use_time: null, created_at: '2026-07-20 08:56:33',
    source_desc: '线下门店签约客户', operator_name: '客服小林'
  },
  {
    id: 9010, user_id: 113, nickname: '南音未歇', gender: 2, benefit_id: 3,
    verify_code: '195627483090', start_time: '2026-09-10 00:00:00', expire_time: '2026-09-25 23:59:59',
    status: 0, use_time: null, created_at: '2026-09-10 21:52:14'
  },
  {
    id: 9011, user_id: 114, nickname: '远山淡影', gender: 0, benefit_id: 2,
    verify_code: '703148625579', start_time: '2026-08-12 00:00:00', expire_time: '2026-09-11 23:59:59',
    status: 1, use_time: '2026-08-30 13:02:47', created_at: '2026-08-12 10:29:58'
  },
  {
    id: 9012, user_id: 104, nickname: '南山悠然客', gender: 0, benefit_id: 6,
    verify_code: '586204317740', start_time: '2026-06-10 00:00:00', expire_time: '2026-09-30 23:59:59',
    status: 0, use_time: null, created_at: '2026-06-10 17:44:21'
  },
  {
    id: 9013, user_id: 106, nickname: '塔林常客·老周', gender: 1, benefit_id: 5,
    verify_code: '328971650042', start_time: '2026-09-02 00:00:00', expire_time: '2026-11-01 23:59:59',
    status: 0, use_time: null, created_at: '2026-09-02 12:18:36'
  },
  {
    id: 9014, user_id: 105, nickname: '梅子黄时雨', gender: 2, benefit_id: 1,
    verify_code: '954120387615', start_time: '2026-05-28 00:00:00', expire_time: '2026-12-31 23:59:59',
    status: 1, use_time: '2026-07-04 09:35:12', created_at: '2026-05-28 15:20:07',
    source_desc: '社群活动抽奖送出', operator_name: '客服小林'
  }
].map(finalize)

// ---------- 指定发放 ----------

function pad(n) { return n < 10 ? '0' + n : '' + n }

function formatTime(d) {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} `
    + `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
}

function randomVerifyCode() {
  let s = ''
  for (let i = 0; i < 12; i++) s += Math.floor(Math.random() * 10)
  return s
}

// 按券种的有效期规则算出生效 / 过期时间
function calcValidRange(benefit) {
  const now = new Date()
  if (benefit.valid_type === 2) {
    const days = Math.max(1, Math.round(benefit.valid_days || 1))
    const end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + days)
    end.setHours(23, 59, 59, 0)
    return { start_time: formatTime(now), expire_time: formatTime(end) }
  }
  const start = benefit.start_date ? `${benefit.start_date} 00:00:00` : formatTime(now)
  const end = benefit.end_date ? `${benefit.end_date} 23:59:59` : ''
  return { start_time: start, expire_time: end }
}

let grantSeq = 9100

// 后台指定发放：生成用户券、累加券种已发数
// options: { benefit, users, num, remark, operatorName }
export function grantBenefit(options) {
  const benefit = benefitOf(options.benefit && options.benefit.id)
  if (!benefit) return []
  const users = options.users || []
  const num = Math.max(1, Math.round(options.num || 1))
  const remark = (options.remark || '').trim()
  const range = calcValidRange(benefit)
  const now = formatTime(new Date())
  const records = []
  users.forEach(user => {
    for (let i = 0; i < num; i++) {
      grantSeq += 1
      records.push(finalize({
        id: grantSeq,
        user_id: user.id,
        nickname: user.nickname,
        gender: user.gender,
        benefit_id: benefit.id,
        verify_code: randomVerifyCode(),
        start_time: range.start_time,
        expire_time: range.expire_time,
        status: 0,
        use_time: null,
        created_at: now,
        source_type: 0,
        source_desc: remark,
        operator_name: options.operatorName || '当前管理员'
      }))
    }
  })
  // 最新发放排最前
  USER_BENEFIT_LIST.unshift(...records.map(r => Object.assign({}, r)))
  benefit.received_count = (benefit.received_count || 0) + records.length
  return records
}

// 某用户已持某券的张数
export function heldCount(userId, benefitId) {
  return USER_BENEFIT_LIST.filter(x => x.user_id === userId && x.benefit_id === benefitId).length
}
